<p>add-catalog-copy works!</p>
